export default "__VITE_ASSET__CHpitqa9__"